export default "__VITE_ASSET__d6dd673f__"